module.exports = __webpack_public_path__ + "static/media/LogoBlu.12961623.svg";